/* Kaching preselection.
   1) Bundle tier: MODE 'last' = top tier, so the price anchors high.
   2) Purchase type: always land on Subscribe & Save, so one-time is an
      active opt-out rather than the default.

   Both run once and back off the moment the shopper touches the widget -
   their own choice always wins. */
(function () {
  var MODE = 'last';
  var TIMEOUT_MS = 12000;
  var started = Date.now();
  var touched = false;
  var tierDone = false;
  var subDone = false;

  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('.kaching-bundles__bar')) touched = true;
  }, true);

  function bundleBars() {
    var scoped = document.querySelectorAll('.kaching-bundles__bars:not(.kaching-bundles__subscriptions) > .kaching-bundles__bar');
    if (scoped.length) return [].slice.call(scoped);
    var wrap = document.querySelector('.kaching-bundles__bars');
    return wrap ? [].slice.call(wrap.children).filter(function (el) {
      return el.className && String(el.className).indexOf('kaching-bundles__bar') > -1;
    }) : [];
  }

  function subBars() {
    return [].slice.call(document.querySelectorAll('.kaching-bundles__subscriptions > .kaching-bundles__bar'));
  }

  function targetIndex(len) {
    if (MODE === 'last') return len - 1;
    if (MODE === 'middle') return Math.floor((len - 1) / 2);
    var n = parseInt(MODE, 10);
    return isFinite(n) ? Math.min(Math.max(n, 0), len - 1) : len - 1;
  }

  function isSelected(el) {
    return el && String(el.className).indexOf('--selected') > -1;
  }

  function pick(el) {
    var hit = el.querySelector('.kaching-bundles__bar-container') || el;
    hit.click();
  }

  function doTier() {
    if (tierDone) return true;
    var bars = bundleBars();
    if (bars.length < 2) return false;
    var target = bars[targetIndex(bars.length)];
    if (!target) return false;
    if (isSelected(target)) { tierDone = true; return true; }
    pick(target);
    return false;
  }

  // The subscribe card is always the first option Kaching renders.
  function doSubscribe() {
    if (subDone) return true;
    var bars = subBars();
    if (!bars.length) return false;
    if (bars.length === 1 || isSelected(bars[0])) { subDone = true; return true; }
    pick(bars[0]);
    return false;
  }

  function attempt() {
    if (touched) return true;
    if (Date.now() - started > TIMEOUT_MS) return true;
    var a = doTier();
    var b = doSubscribe();
    return a && b;
  }

  if (attempt()) return;

  var mo = new MutationObserver(function () {
    if (attempt()) mo.disconnect();
  });
  mo.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, TIMEOUT_MS + 500);
})();
